// Validazione via jQuery
// ----------------------

// import validate from "jquery-validation";

// $.validator.setDefaults({
//     ignore: []
// });

// $("form").each(function(index, element) {
//     // element == this
//     $(this).validate({
//         errorElement: "div",
//         errorClass: "isError",
//         errorPlacement: function(error, element) {
//             if (element.hasClass("validateAsPrivacy")) {
//                 let privacyLabel = element.next("label");
//                 error.insertAfter(privacyLabel);
//             } else if (element.is("#newsletter-email")) {
//                 let button = element.next("button");
//                 error.insertAfter(button);
//             } else {
//                 error.insertAfter(element);
//             }
//         }
//     });
// });

// $(".validateAsText").each(function() {
//     $(this).rules("add", {
//         messages: {
//             required: "Questo campo è obbligatorio"
//         }
//     });
// });

// $(".validateAsEmail").each(function() {
//     $(this).rules("add", {
//         email: true,
//         messages: {
//             required: "Questo campo è obbligatorio",
//             email: "Si prega di inserire un'indirizzo email valido"
//         }
//     });
// });

// $(".validateAsNumber").each(function() {
//     $(this).rules("add", {
//         digits: true,
//         messages: {
//             required: "Questo campo è obbligatorio",
//             digits: "Si prega di inserire solo numeri"
//         }
//     });
// });

// $(".validateAsPrivacy").each(function() {
//     $(this).rules("add", {
//         required: true,
//         messages: {
//             required: "È necessario accettare la nostra privacy"
//         }
//     });
// });

// Abilita la sostituzione del nome della label del file input

$("input[type='file']").each(function() {
    var $input = $(this),
        $label = $input.parent().next("label"),
        labelVal = $label.html();

    $input.on("change", function(e) {
        var fileName = "";

        if (this.files && this.files.length > 1)
            fileName = (
                this.getAttribute("data-multiple-caption") || ""
            ).replace("{count}", this.files.length);
        else if (e.target.value) fileName = e.target.value.split("\\").pop();

        if (fileName) $label.find("span").html(fileName);
        else $label.html(labelVal);
    });

    // Firefox bug fix
    $input
        .on("focus", function() {
            $input.addClass("has-focus");
        })
        .on("blur", function() {
            $input.removeClass("has-focus");
        });
});

var input = $('input');

input.attr('size', '');